import React, { useEffect, useState } from "react";

const BrowserCompatibility = ({ children, Styled }) => {
  const [isFallback, setIsFallback] = useState(false);
  const [isObsolete, setIsObsolete] = useState(false);
  const classes = [];
  useEffect(() => {
    const isIE10 = () => {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }
      return false;
    };
    const isIE11 = () => {
      var ua = window.navigator.userAgent;
      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }
      return false;
    };
    setIsObsolete(isIE10());
    setIsFallback(isIE11());
  }, [setIsFallback, setIsObsolete]);
  if (isObsolete) classes.push("is-obsolete");
  if (isFallback) classes.push("is-fallback");
  if (!isObsolete && !isFallback) classes.push("is-modern");
  return (
    <div className={classes.join(" ")}>
      {isObsolete ? (
        <div
          style={{
            background: "red",
            color: "white",
            padding: "10px 20px",
            textAlign: "center",
            width: "100%",
            height: "44px",
          }}
        >
          This Browser is Out of Date. We recommend{" "}
          <a href="http://browsehappy.com" style={{ color: "yellow" }}>
            an update
          </a>
          .
        </div>
      ) : null}
      {isFallback ? (
        <Styled>
          {React.cloneElement(children, { isFallback, isObsolete })}
        </Styled>
      ) : (
        React.cloneElement(children, { isFallback, isObsolete })
      )}
    </div>
  );
};

export default BrowserCompatibility;
